import React, { Component } from "react";

import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton/IconButton';
import FlatButton from 'material-ui/FlatButton';
import Box from '../ui/Box';

import DataService from '../../services/DataService';
var ds = DataService;

const HeaderIconButtonStyle = {
  width: '60px',
  height: '60px'
};

export default class FeedbackResponses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props && this.props.templateId ? this.props.templateId : null,
      maxItems: 1,
      totalCount: 0,
      showDetails: false,
      responseRecieved: [],
      currentPage: 0
    }
  }

  componentDidMount() {
    this.getResponses();
  }

  getResponses(currentPage = 0) {
    ds.getFeedBackResponses(this.state.id, this.state.maxItems, currentPage,
      data => {
        console.log('in data = ', data);
        if (data && data.docs && data.docs.length) {
          this.setState({
            responseRecieved: data.docs,
            totalCount: data.count

          }, () => {
            this.setState({
              showDetails: true
            })
          });
        }
      },
      err => { }
    );
  }

  onPageChange(reqFrom, e) {
    switch (reqFrom) {
      case 'next':
        let nextPage = this.state.currentPage + 1;
        this.setState({
          currentPage: nextPage,
          showDetails: false
        }, () => {
          this.getResponses(nextPage)
        });
        break;

      case 'prev':
        let prevPage = this.state.currentPage - 1;
        if (prevPage !== -1) {
          this.setState({
            currentPage: prevPage,
            showDetails: false
          }, () => {
            this.getResponses(prevPage)
          });
        }
        break;

      case 'text':
        if (e.target && e.target.value && !isNaN(e.target.value) && (e.target.value > 0 && e.target.value <= this.state.totalCount)) {
          if (e.target.value != -1) {
            let page = parseInt(e.target.value) - 1;
            this.setState({
              currentPage: page,
              showDetails: false
            }, () => {
              this.getResponses(page)
            });
          }
          return;
        }
        if (e.target.value <= 0) {
          this.setState({
            currentPage: 0
          })
        }
        else if (e.target.value > this.state.totalCount) {
          this.setState({
            currentPage: this.state.totalCount - 1
          })
        }
        break;
    }
  }

  render() {
    return (
      <div>
        <Box header='FeedBack Response(s)'>
          {
            this.state.responseRecieved && this.state.responseRecieved.length && this.state.showDetails ?
              <div className="row customRow">
                {
                  this.state.responseRecieved[0] && this.state.responseRecieved[0].guestUser ?
                    <div className="col-sm-12 pl-0px">
                      <div className="col-sm-12 pl-0px user-name mb-1rem">
                        {
                          this.state.responseRecieved[0].guestUser.guest_name ?
                            this.state.responseRecieved[0].guestUser.guest_name
                            : ''
                        }
                      </div>

                      <div className="col-sm-12 pl-0px mb-0-4rem">
                        Phone No: &nbsp;
                        {
                          this.state.responseRecieved[0].guestUser.guest_phone ?
                            this.state.responseRecieved[0].guestUser.guest_phone
                            : ''
                        }
                      </div>

                      <div className="col-sm-12 pl-0px mb-0-4rem">
                        Email: &nbsp;
                        {
                          this.state.responseRecieved[0].guestUser.guest_email ?
                            this.state.responseRecieved[0].guestUser.guest_email
                            : ''
                        }
                      </div>

                      <div className="col-sm-12 pl-0px mb-0-4rem">
                        Check-in: &nbsp;
                        {
                          this.state.responseRecieved[0].guestUser.check_in_time ?
                            new Date(this.state.responseRecieved[0].guestUser.check_in_time).toDateString()
                            : ''
                        }
                      </div>

                      <div className="col-sm-12 pl-0px mb-0-4rem">
                        Check-out: &nbsp;
                        {
                          this.state.responseRecieved[0].guestUser.check_out_time ?
                            new Date(this.state.responseRecieved[0].guestUser.check_out_time).toDateString()
                            : ''
                        }
                      </div>

                      <div className="col-sm-12 pl-0px mb-0-4rem">
                        Room Details: &nbsp;
                        {
                          this.state.responseRecieved[0].guestUser.hotel_room_id ?
                            this.state.responseRecieved[0].guestUser.hotel_room_id.name + '  (floor - ' +
                            this.state.responseRecieved[0].guestUser.hotel_room_id.floor + ' )'
                            : ''
                        }
                      </div>

                      <div className="row">
                        <div className="col-sm-8"></div>

                        <div className="col-sm-4 text-right">
                          <FlatButton style={{ top: '0.7rem', padding: '0px' }} onClick={this.onPageChange.bind(this, 'prev')} disabled={this.state.currentPage == 0}>
                            <IconButton
                              style={HeaderIconButtonStyle}
                            >
                              <i className="material-icons">
                                keyboard_arrow_left
                              </i>
                            </IconButton>
                          </FlatButton>

                          <TextField
                            required
                            id="outlined-required"
                            defaultValue={this.state.currentPage + 1}
                            value={this.state.currentPage + 1}
                            variant="outlined"
                            size="small"
                            type="number"
                            style={{ width: '50px' }}
                            onChange={this.onPageChange.bind(this, 'text')}
                            InputProps={{
                              min: 1,
                              max: this.state.totalCount
                            }}
                          />

                          {' of '} &nbsp;

                          {
                            Number(this.state.totalCount)
                          }

                          <FlatButton style={{ top: '0.7rem', padding: '0px' }} onClick={this.onPageChange.bind(this, 'next')} disabled={this.state.currentPage + 1 == this.state.totalCount}>
                            <IconButton
                              style={HeaderIconButtonStyle}
                            >
                              <i className="material-icons">
                                keyboard_arrow_right
                              </i>
                            </IconButton>
                          </FlatButton>
                        </div>
                      </div>

                      <div className="col-sm-12 pl-0px mt-1rem">
                        <div className="pl-0px user-name mb-0-4rem">
                          Response {this.state.currentPage + 1}
                        </div>

                        {
                          this.state.responseRecieved[0].feedback_response &&
                            this.state.responseRecieved[0].feedback_response.survey_sections &&
                            this.state.responseRecieved[0].feedback_response.survey_sections.length ?
                            <div className="col-sm-12 pl-0px">
                              {
                                this.state.responseRecieved[0].feedback_response.survey_sections.map((section, index) => {
                                  return <div className="col-sm-12 pl-0px pr-0px mt-0-7rem" key={index + section}>
                                    <Box header={section.title}>
                                      <div className="col-sm-12 pl-0px section-desc">
                                        {section.description}
                                      </div>

                                      <div className="col-sm-12 pl-0px">
                                        {
                                          section.questions && section.questions.length ?
                                            <div className="col-sm-12 pl-0px">
                                              {
                                                section.questions.map((que, queIndex) => {
                                                  return <div className="col-sm-12 pl-0px mt-0-7rem" key={queIndex + que.question_id}>
                                                    <div className="col-sm-12 pl-0px">
                                                      <b className="section-que">
                                                        Q{queIndex + 1}.&nbsp; {que.title}
                                                      </b>
                                                    </div>

                                                    <div className="col-sm-12 pl-0px section-ans">
                                                      Ans.&nbsp; {que.answer}
                                                    </div>
                                                  </div>
                                                })
                                              }
                                            </div>

                                            :
                                            <p className="no-response" style={{ textAlign: 'center' }}>
                                              No Question - Answer(s) Present!
                                          </p>
                                        }
                                      </div>
                                    </Box>
                                  </div>
                                })
                              }
                            </div>

                            : <p className="no-response" style={{ textAlign: 'left' }}>No Answers Present!</p>
                        }

                      </div>
                    </div>

                    : <p className="no-response" style={{ textAlign: 'left' }}>No User Deatils Present!</p>
                }
              </div>

              : <p className="no-response">No Response Submitted Yet!</p>
          }
        </Box>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./components/feedback/FeedbackResponses.js